import { TrashOutlineIcon } from '../../../buttons/IconButtons';
import { FILE_TYPE } from '../../../../Helpers/fileType';
import React from 'react';
import { EMPTY_VALUES, formatBytes, getIconByExtOrFile } from '../../../../Apis/functions';
import { ACTION_MODEL } from '../../../../Helpers/ActionModel';
import CustomFileCard from '../../../CustomFileCard';
import { useTranslation } from 'react-i18next';
import { FormHelperText } from '@mui/material';
import { CustomStyleFormHelperText } from '../../../Styles';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.m
 *
 * @param model photoPicker: component model
 * @param event handleDelete: required if actionModel === ACTION_MODEL.UPDATE and photo deletion is needed
 * @param model accept: file formats and sizes accepted by the component
 * @param boolean showBtnDelete: default value is true, must be set to false if selected files are not required
 * @param string actionModel: string with option "create" or "update", this comes from the ACTION_MODEL
 * @param boolean inModal: indicates if it's being used inside a modal; this applies to the update action
 * @param boolean disabled: for the disabled component
 */
const PickerFilePreview = ({
    photoPicker,
    handleDelete,
    accept,
    showBtnDelete = true,
    actionModel,
    inModal = false,
    disabled = false,
    emptyFields,
}) => {
    const { t } = useTranslation();
    const typeImage = accept.name === FILE_TYPE.IMAGE.name;
    const prevModal = photoPicker?.selfieSrc || photoPicker?.srcSelected || photoPicker?.preview;
    const prev = inModal
        ? prevModal
        : photoPicker?.selfieSrc || photoPicker?.srcSelected || photoPicker?.previewImage || photoPicker?.preview;
    const borderButton =
        photoPicker?.fileSelected || photoPicker?.selfieSrc || (actionModel && actionModel == ACTION_MODEL.UPDATE);
    const imgWh = !photoPicker?.fileSelected && !photoPicker?.selfieSrc && !photoPicker?.previewImage;

    const PreviewFile = ({ photoPicker }) => {
        let fileSelected = photoPicker?.fileSelected || photoPicker?.previewImage;

        const Icon = getIconByExtOrFile(fileSelected);
        return (
            <>
                <CustomFileCard
                    title={fileSelected?.name || EMPTY_VALUES.DEFAULT}
                    Icon={Icon}
                    subtitle={fileSelected ? formatBytes(fileSelected.size) : EMPTY_VALUES.DEFAULT}
                    showBtnDelete={true}
                    clickBtnDelete={() => {
                        if (!disabled && handleDelete) handleDelete();
                    }}
                    classes='card-shades-300-50-2px border-radius-8px w-100'
                />
            </>
        );
    };
    const PreviewImage = ({
        preview,
        imgWh,
        borderButton,
        typeImage,
        showBtnDelete,
        handleDelete,
        disabled,
        emptyFields,
    }) => {
        return (
            <div
                className={`photo-picker-main-preview d-flex justify-content-center align-items-center text-center
        ${borderButton ? 'prev-border-bottom' : ''}
        ${typeImage ? 'h-276px photo-picker-bg-image' : 'h-120px photo-picker-bg-file'}
        ${showBtnDelete && !disabled ? 'show-overlay' : ''}
        ${emptyFields ? 'photo-picker-error' : ''}
    `}
            >
                <div className='overlay'>
                    <button
                        className={`hover-button ${typeImage ? 'btn-w-image' : 'btn-w-file'} desktop-only`}
                        onClick={() => {
                            if (!disabled && handleDelete) handleDelete();
                        }}
                    >
                        <TrashOutlineIcon className={`${typeImage ? 'icon-w-image' : 'icon-w-file'}`} />
                    </button>
                </div>
                <div className='photo-picker-image'>
                    <img className={imgWh ? 'default' : 'preview'} src={preview} />
                </div>
            </div>
        );
    };

    return (
        <>
            {!typeImage ? (
                (photoPicker?.fileSelected || photoPicker?.previewImage) ? (
                    <PreviewFile photoPicker={photoPicker} />
                ) : (
                    photoPicker?.selfieSrc && (
                        <PreviewImage
                            preview={prev}
                            imgWh={imgWh}
                            borderButton={borderButton}
                            typeImage={true}
                            showBtnDelete={showBtnDelete}
                            handleDelete={handleDelete}
                            disabled={disabled}
                            emptyFields={emptyFields}
                        />
                    )
                )
            ) : (
                <>
                    <PreviewImage
                        preview={prev}
                        imgWh={imgWh}
                        borderButton={borderButton}
                        typeImage={typeImage}
                        showBtnDelete={showBtnDelete}
                        handleDelete={handleDelete}
                        disabled={disabled}
                        emptyFields={emptyFields}
                    />
                    {emptyFields && (
                        <FormHelperText
                           error
                            sx={{ ...CustomStyleFormHelperText(false) }}
                        >
                            {t('requiredField')}
                        </FormHelperText>
                    )}
                </>
            )}
        </>
    );
};

export default PickerFilePreview;
